export default __webpack_public_path__ + "static/media/pikachu.d20bdd5d.png";